import { counselSchema } from "@/features/case-evaluation/types/counsel";
import { userSchema } from "@/features/dashboard/types/user";
import { z } from "zod";
import { caseMemberSchema } from "./case-member";

export const caseRecordUserSchema = z.object({
	id: z.string().optional(),
	reference_id: z.string().optional(),
	invitation_code: z.string().optional(),
	status: z.string().optional(),
	role: z.string().optional(),
	law_firm: z.string().optional(),
	law_firm_email: z.string().optional(),
	counsels: counselSchema.optional(),
	user: userSchema.optional(),
	member: caseMemberSchema.optional(),
	invited_at: z.string().optional(),
	can_add_activity: z.boolean().optional(),
	accepted_at: z.string().optional(),
	created_at: z.string().optional(),
	updated_at: z.string().optional(),
	is_lead_cousel: z.string().optional(),
});

export type CaseRecordUser = z.infer<typeof caseRecordUserSchema>;
